// extracted by mini-css-extract-plugin
export default {"formEntryPage":"FormEntryPage_formEntryPage__fv3q4","formEntryPageStandFirst":"FormEntryPage_formEntryPageStandFirst__WJRlw"};